import axiosInstance from "@/api/axiosConfig";

export type ComingUpKind = "filing" | "expiration" | "appointment" | "reminder";
export type ComingUpScope = "mine" | "team";

/** `GET /api/dashboard/coming-up` row: something falling due, soonest first. */
export type ComingUpItem = {
  id: string;
  kind: ComingUpKind;
  title: string;
  detail: string | null;
  /** `YYYY-MM-DD`. */
  due_date: string | null;
  client_id: string | null;
  client_name: string | null;
  matter_id: string | null;
  owner_name: string | null;
  overdue: boolean;
  path: string | null;
};

export const ComingUpAPI = {
  async list(scope: ComingUpScope): Promise<ComingUpItem[]> {
    const { data } = await axiosInstance.get<{ items?: ComingUpItem[] }>(
      "/dashboard/coming-up",
      {
        params: { scope }
      }
    );
    return data.items ?? [];
  }
};
